import { render, staticRenderFns } from "./UserUsageReport.vue?vue&type=template&id=2896c039&scoped=true"
import script from "./UserUsageReport.vue?vue&type=script&lang=ts"
export * from "./UserUsageReport.vue?vue&type=script&lang=ts"
import style0 from "./UserUsageReport.vue?vue&type=style&index=0&id=2896c039&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896c039",
  null
  
)

export default component.exports